// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonWithLoading_button__26uHh","appearAnimation":"ButtonWithLoading_appearAnimation__13cMT","showSpinner":"ButtonWithLoading_showSpinner__1eyOl"};